const bioRoundedContent = Object.freeze([
  {
    blockId: 7,
    // Tile data
    size: {
      w: 1,
      h: 1
    },
    position: {
      y: 1,
      x: 1
    },
    innerTileStyle: {
      borderRadius: '100%'
    },
    isTileCreator: true,

    // content data
    content_type: 'asset',
    asset_type: 'photo',
    blockSubtype: 'image',
    blockType: 'content',
    alt_text: 'Rounded image',
    description: 'Add Image',
    tile_inner_zf_image: {
      cropData: {
        borderRadius: 100
      }
    }
  },
  {
    blockId: 8,
    size: {
      w: 1,
      h: 1
    },
    position: {
      y: 1,
      x: 3
    },
    content_type: 'asset',
    asset_type: 'photo',
    isTileCreator: true,
    blockSubtype: 'image',
    blockType: 'content',
    innerTileStyle: {
      borderRadius: '100%'
    },
    alt_text: 'Rounded image',
    description: 'Add Image',
    tile_inner_zf_image: {
      cropData: {
        borderRadius: 100
      }
    }
  },
  {
    blockId: 9,
    size: {
      w: 1,
      h: 1
    },
    position: {
      y: 1,
      x: 2
    },
    tile_caption: '<p><strong>Jenny Smith</strong></p><p>Managerial manager</p>',
    content_type: 'text',
    blockType: 'content',
    blockSubtype: 'text',
    isTileCreator: false
  },
  {
    blockId: 10,
    size: {
      w: 1,
      h: 1
    },
    position: {
      y: 1,
      x: 4
    },
    tile_caption: '<p><strong>Jenny Smith</strong></p><p>Managerial manager</p>',
    content_type: 'text',
    blockType: 'content',
    blockSubtype: 'text',
    isTileCreator: false
  }
]);

export default bioRoundedContent;